module.exports = __webpack_public_path__ + "img/repeatattempts.e7ce4756.svg";